import axios, { AxiosInstance } from 'axios';
import { setupInterceptors } from '@/services/api/interceptors';

const rawApiUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3032';
const API_BASE_URL = rawApiUrl.endsWith('/api')
  ? rawApiUrl
  : rawApiUrl.endsWith('/')
    ? `${rawApiUrl}api`
    : `${rawApiUrl}/api`;

export const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

setupInterceptors(apiClient);

export default apiClient;

